import { type FC, useState } from "react";
import { Link } from "src/router";
import { AdArtifactFileDrawer } from "src/pages/agents/components/ad-artifact-file-drawer";

export const AdArtifactLink: FC<{
  href: string;
  interactionId?: string;
  children: React.ReactNode;
}> = ({ href, interactionId, children }) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    setIsDrawerOpen(true);
  };

  const normalizePath = (path: string): string => {
    return path.replace(/^\.\//, "");
  };

  const normalizedPath = normalizePath(href);

  return (
    <>
      <Link
        href="#"
        onClick={handleClick}
        color="var(--chakra-colors-link-default)"
        fontSize="inherit"
        style={{ cursor: "pointer" }}
      >
        {children}
      </Link>
      {isDrawerOpen && (
        <AdArtifactFileDrawer
          isOpen={isDrawerOpen}
          onClose={() => setIsDrawerOpen(false)}
          interactionId={interactionId}
          filename={normalizedPath}
        />
      )}
    </>
  );
};
